<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>
          يومية الاسم
        </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <div class="ion-padding text-center">
        <ion-text color="dark">
          <h1 class="text-bold">404</h1>
        </ion-text>
        <ion-text color="dark">
          <p>
           Not Found
          </p>
        </ion-text>
      </div>
    </ion-content>
  </div>
</template>

<script>
  export default {
    name: 'not-found'
  }
</script>
